const UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-8][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
/** Navigation is a hint, never authority. The server revalidates C/W/D. */
export function vishingChatContext(pathname: string, search: string, activeDomainId: string | null) {
  if (pathname !== '/vishing' && !pathname.startsWith('/vishing/')) return undefined;
  const candidate = new URLSearchParams(search).get('domainId');
  const domainId = candidate && UUID.test(candidate) ? candidate : activeDomainId && UUID.test(activeDomainId) ? activeDomainId : undefined;
  return { moduleContext: 'vishing' as const, domainId };
}
